import axios from 'axios'

export const companiesMapionBizBannersTemplatesCsvDownloads = {
  namespaced: true,
  state: {
    data: [],
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
  },
  actions: {
    downloadTemplate({ commit, rootState }, templateId) {
      commit('prepareConnect')

      return axios
        .get(`/api/companies/${ rootState.route.params.company_uuid }/oc/mapion_biz/banners/templates/${ templateId }/csv_download`, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/zip' }))
          link.download = 'template.zip'
          link.click()
          commit('stopLoading')
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
  }
}
